export enum Spec {
  AppControllerLayoutFix = 'specs.siteSearch.AppControllerLayoutFix',
  NewResultsPerPageDefaultValue = 'specs.siteSearch.NewResultsPerPageDefaultValue',
  ProGallery = 'specs.siteSearch.ProGallery',
  UseWarmupData = 'specs.siteSearch.UseWarmupData',
  MobileSettings = 'specs.siteSearch.MobileSettings',
  DisableAllTabByDefault = 'specs.siteSearch.DisableAllTabByDefault',
  RemoveCorruptedSiteSearch = 'specs.siteSearch.RemoveCorruptedSiteSearch',
}
